export function Spinner() {
  return <span className="datepicker-spinner" aria-hidden="true" />
}
